import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const OpenRoute = ({children}) =>{

    const token = useSelector((state)=>state.auth.token);
    // console.log("Your admin is : ",isAdmin)

    if(token !== "null" ){
        return children;
    }
    else{
        return <Navigate to="/"/>
    }
 
}

export default OpenRoute
